(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-infinite-scroll"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collection-infinite-scroll')) {
    customElements.define(
      'collection-infinite-scroll',
      class CollectionInfiniteScroll extends HTMLElement {
        #observer;
        #requests = new Map();
        #loading = new Set();
        #statusTimer;

        connectedCallback() {
          this.#resetScrollOnReload();
          if (this.dataset.enabled !== 'true') return;

          this.#observer = new IntersectionObserver(this.#handleIntersections, {
            rootMargin: '100px 0px',
          });
          this.#syncSentinels();
          this.#prefetch('previous');
          this.#prefetch('next');
        }

        #resetScrollOnReload() {
          const navigation = performance.getEntriesByType('navigation')[0];
          if (navigation?.type !== 'reload') return;

          history.scrollRestoration = 'manual';
          window.scrollTo(0, 0);

          const reset = () => {
            window.scrollTo(0, 0);
            history.scrollRestoration = 'auto';
          };

          if (document.readyState === 'complete') {
            reset();
          } else {
            window.addEventListener('pageshow', reset, { once: true });
          }
        }

        disconnectedCallback() {
          this.#observer?.disconnect();
          window.clearTimeout(this.#statusTimer);
        }

        #handleIntersections = (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            if (entry.target === this.querySelector('[data-infinite-scroll-previous]')) {
              this.#load('previous');
            }
            if (entry.target === this.querySelector('[data-infinite-scroll-next]')) {
              this.#load('next');
            }
          }
        };

        #items() {
          return Array.from(this.querySelectorAll(':scope > [data-infinite-scroll-item]'));
        }

        #page(direction) {
          const pages = this.#items().map((item) => Number(item.dataset.page));
          if (!pages.length) return;

          const boundary = direction === 'previous' ? Math.min(...pages) : Math.max(...pages);
          const page = boundary + (direction === 'previous' ? -1 : 1);
          const lastPage = Number(this.dataset.lastPage);
          if (page < 1 || page > lastPage) return;
          return page;
        }

        #url(page, renderSection) {
          const url = new URL(window.location.href);
          url.hash = '';
          url.searchParams.set('page', String(page));
          if (renderSection) {
            url.searchParams.set('section_id', this.dataset.sectionId);
          } else {
            url.searchParams.delete('section_id');
          }
          return url;
        }

        #request(page) {
          if (this.#requests.has(page)) return this.#requests.get(page);

          const request = fetch(this.#url(page, true), {
            headers: {
              Accept: 'text/html',
              'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'same-origin',
          })
            .then((response) => {
              if (!response.ok) throw new Error(this.dataset.errorText);
              return response.text();
            })
            .then((html) => {
              const documentFragment = new DOMParser().parseFromString(html, 'text/html');
              const source = Array.from(documentFragment.querySelectorAll('collection-infinite-scroll')).find(
                (element) => element.dataset.sectionId === this.dataset.sectionId
              );
              if (!source) throw new Error(this.dataset.errorText);

              return {
                lastPage: Number(source.dataset.lastPage),
                items: Array.from(source.querySelectorAll(':scope > [data-infinite-scroll-item]')),
              };
            })
            .catch((error) => {
              this.#requests.delete(page);
              throw error;
            });

          this.#requests.set(page, request);
          return request;
        }

        #prefetch(direction) {
          const page = this.#page(direction);
          if (page) this.#request(page).catch(() => {});
        }

        async #load(direction) {
          const page = this.#page(direction);
          if (!page || this.#loading.has(direction)) return;

          this.#loading.add(direction);
          this.#setStatus('loading', this.dataset.loadingText);

          try {
            const result = await this.#request(page);
            this.dataset.lastPage = String(result.lastPage);

            const existingIds = new Set(this.#items().map((item) => item.dataset.productId));
            const newItems = result.items
              .filter((item) => !existingIds.has(item.dataset.productId))
              .map((item) => document.importNode(item, true));

            if (newItems.length) {
              const fragment = document.createDocumentFragment();
              for (const item of newItems) fragment.append(item);

              if (direction === 'previous') {
                const anchor = this.#items()[0];
                const previousTop = anchor?.getBoundingClientRect().top || 0;
                this.insertBefore(fragment, anchor || this.querySelector('[data-infinite-scroll-next]'));
                if (anchor) window.scrollBy(0, anchor.getBoundingClientRect().top - previousTop);
              } else {
                this.insertBefore(fragment, this.querySelector('[data-infinite-scroll-next]'));
              }
            }

            history.pushState({}, '', this.#url(page, false));
            this.#setStatus('loaded', this.dataset.loadedText);
          } catch (error) {
            this.#setStatus('error', error.message || this.dataset.errorText);
          } finally {
            this.#loading.delete(direction);
            this.#syncSentinels();
            this.#prefetch(direction);
          }
        }

        #syncSentinels() {
          this.#observer?.disconnect();

          const previous = this.querySelector('[data-infinite-scroll-previous]');
          const next = this.querySelector('[data-infinite-scroll-next]');
          if (previous) {
            previous.hidden = !this.#page('previous');
            if (!previous.hidden) this.#observer?.observe(previous);
          }
          if (next) {
            next.hidden = !this.#page('next');
            if (!next.hidden) this.#observer?.observe(next);
          }
        }

        #setStatus(state, text) {
          const status = this.querySelector('[data-infinite-scroll-status]');
          const statusText = this.querySelector('[data-infinite-scroll-status-text]');
          if (!status || !statusText) return;

          window.clearTimeout(this.#statusTimer);
          this.dataset.state = state;
          this.setAttribute('aria-busy', String(state === 'loading'));
          status.hidden = false;
          statusText.textContent = text || '';

          if (state === 'loaded') {
            this.#statusTimer = window.setTimeout(() => {
              status.hidden = true;
              delete this.dataset.state;
            }, 1200);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
